export const USER_TOKEN = 'USER_TOKEN'
export const LANG_STORAGE_KEY = 'lang_key'
export const USER_INFO = 'USER_INFO'
